/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Create_Aria_LabelInputs */

const en_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new project`)
};

const fr_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un nouveau projet`)
};

const de_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Projekt erstellen`)
};

const it_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un nuovo progetto`)
};

const ru_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый проект`)
};

const es_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nuevo proyecto`)
};

const zh_cn2_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新项目`)
};

const ja_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロジェクトを作成する`)
};

const hi_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया प्रोजेक्ट बनाएं`)
};

const pt_pt2_new_project_create_aria_label = /** @type {(inputs: New_Project_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo projeto`)
};

/**
* | output |
* | --- |
* | "Create new project" |
*
* @param {New_Project_Create_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_create_aria_label = /** @type {((inputs?: New_Project_Create_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Create_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_create_aria_label(inputs)
	if (locale === "de") return de_new_project_create_aria_label(inputs)
	if (locale === "it") return it_new_project_create_aria_label(inputs)
	if (locale === "ru") return ru_new_project_create_aria_label(inputs)
	if (locale === "es") return es_new_project_create_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_create_aria_label(inputs)
	if (locale === "ja") return ja_new_project_create_aria_label(inputs)
	if (locale === "hi") return hi_new_project_create_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_create_aria_label(inputs)
	return en_new_project_create_aria_label(inputs)
});